import * as THREE from 'three';
import { FlyControls } from 'three/examples/jsm/controls/FlyControls.js';
import { StateManager } from "./statemanager";
import { State } from "./state";
import { MapManager } from "../maps/mapmanager";
import { DataManager, GDM } from "../helpers/datamanager";
import { EffectManager } from '../effects/effectmanager';
import { AnimationData } from '../loaders/zmo';
import { NpcPawn } from '../pawns/npcpawn';
import { CharPawn } from '../pawns/charpawn';
import { SkeletonAnimator } from '../animators/skeletonanimator';

export class ParticleTestState extends State {
    DM: any;
    world: any;
    objects: any[];
    controls: any;

    constructor() {
        super();
        this.DM = new DataManager();
        this.world = null;
        this.objects = [];
    }

    async prepare(): Promise<void> {
        await new Promise<void>((resolve) => {
            GDM.get("npc_chars", function () {
                resolve();
            });
        });
    }

    spawnBonfire() {
        const bonfire = new NpcPawn();
        bonfire.setModel(801, () => {});
        bonfire.rootObj.position.set(5200, 5280, -5);
        bonfire.playIdleMotion();
        this.objects.push(bonfire);
        scene.add(bonfire.rootObj);
    }

    spawnRandom() {
        for (let i = 0; i < 100; ++i) {
            const charList = GDM.getNow("npc_chars");
            let charIdx;
            do {
                charIdx = Math.floor(Math.random() * 1000);
            } while (!charList.characters[charIdx]);
            const npc = new NpcPawn();
            npc.setModel(charIdx, () => {});
            npc.rootObj.position.set(
                5200 + Math.random() * 90 - 45,
                5280 + Math.random() * 90 - 45,
                -5
            );
            npc.playIdleMotion();
            this.objects.push(npc);
            scene.add(npc.rootObj);
        }
    }

    fuckingMeteors() {
        let rootObj = new THREE.Object3D();
        rootObj.position.set(
            5200 + Math.random() * 20 - 10,
            5280 + Math.random() * 20 - 10,
            -5
        );
        scene.add(rootObj);
        EffectManager.loadEffect(
            "3Ddata\\EFFECT\\_RUNASTON_01.EFT",
            function (effect: any) {
                rootObj.add(effect.rootObj);
                rootObj.add(effect.rootObj2);
                effect.play();
                effect.on("finish", function () {
                    console.log("EFFECT FINISHED!");
                });
            }
        );
    }

    fuckingPointer() {
        const rootObj = new THREE.Object3D();
        rootObj.position.set(
            5200 + Math.random() * 20 - 10,
            5280 + Math.random() * 20 - 10,
            -5
        );
        scene.add(rootObj);
        EffectManager.loadEffectByIdx(296, function (effect: any) {
            rootObj.add(effect.rootObj);
            rootObj.add(effect.rootObj2);
            effect.play();
            effect.on("finish", function () {
                console.log("EFFECT FINISHED!");
            });
        });
    }

    enter() {
        debugGui.addButton("Spawn Random NPCs", this.spawnRandom.bind(this));
        debugGui.addButton("Spawn Bonfire", this.spawnBonfire.bind(this));
        debugGui.addButton("Test Meteors", this.fuckingMeteors.bind(this));
        debugGui.addButton("Test Pointer", this.fuckingPointer.bind(this));
        let controls = new FlyControls(camera, renderer.domElement);
        controls.movementSpeed = 100;
        controls.rollSpeed = Math.PI / 24;
        controls.dragToLook = false; // Any mouse button to rotate
        this.controls = controls;
        camera.position.x = 5150;
        camera.position.y = 5333;
        camera.position.z = 39;
        if (1) {
            const wm = new MapManager();
            wm.rootObj.position.set(5200, 5200, 0);
            wm.setMap(5, function () {
                console.log("Map Ready");
            });
            this.world = wm;
            scene.add(wm.rootObj);
            const charObj = new CharPawn();
            charObj.setGender(0, function () {
                charObj.setModelPart(3, 1, 0);
                charObj.setModelPart(4, 1, 0);
                charObj.setModelPart(5, 1, 0);
                charObj.setModelPart(7, 202, 0);
                charObj.setModelPart(8, 2, 0);
                const animPath = "3DData/Motion/Avatar/EMPTY_STOP1_M1.ZMO";
                AnimationData.load(animPath, function (zmoData: any) {
                    const anim = new SkeletonAnimator(charObj.skel, zmoData);
                    anim.play();
                });
            });
            charObj.rootObj.position.set(5205, 5285, -5);
            charObj.rootObj.rotateOnAxis(new THREE.Vector3(0, 0, 1), Math.PI);
            charObj.rootObj.scale.set(1.2, 1.2, 1.2);
            const effect = EffectManager.loadEffectByIdx(302, function () {
                effect.play();
                charObj.rootObj.add(effect.rootObj);
            });
            scene.add(charObj.rootObj);
        }
    }

    leave() {}

    update(delta: any) {
        this.controls.update(delta);
        if (this.world && this.world.isLoaded) {
            this.world.setViewerInfo(camera.position);
            this.world.update(delta);
        }
        for (let i = 0; i < this.objects.length; ++i) {
            this.objects[i].update(delta);
        }
    }
}

/**
 * @constructor
 */

StateManager.register("particle", ParticleTestState);
